module.exports = __webpack_public_path__ + "img/xl_bk.e0562369.jpg";